import { createFileRoute } from '@tanstack/react-router';

import { AuthRequiredPageWidget } from '@features/auth/pages/AuthRequiredPage';

export const Route = createFileRoute('/auth/required')({
  component: Page,
  validateSearch: (search) => {
    return {
      back: search?.back,
    } as { back?: string };
  },
});

function Page() {
  const search = Route.useSearch();
  return <AuthRequiredPageWidget back={search.back} />;
}
